export const appConfigurations = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  ADMIN_PORTAL_USER_ADD_URL: process.env.REACT_APP_USER_ADD_URL,
  GOOGLE_API_KEY: process.env.REACT_APP_GOOGLE_API_KEY,
};
